<ion-header> 

  <ion-toolbar >
    <img src="/assets/images/logo.png" class="logo" alt="logo" [routerLink]="['modulo-gc/gc-funcoes']">

    <ion-buttons slot="end">

      <ion-item lines="none" class="ion-no-margin ion-no-padding" *ngIf="showNotificacaoNovosDocsEnviados && inscricoesRecentementeAtualizadas.length>0">
        <ion-badge mode="ios" >{{inscricoesRecentementeAtualizadas.length}}</ion-badge>
        <ion-icon name="notifications-outline" 
                  slot="end" 
                  (click)="openPopoverListarInscricoes($event)" ></ion-icon>
      </ion-item>

      <ion-item lines="none" class="ion-no-margin ion-no-padding" *ngIf="usuarioLogado?.id">
        <ion-icon name="grid-outline" 
              slot="end" 
              [routerLink]="['/modulo-gc/gc-funcoes']" ></ion-icon>
      </ion-item>
    
              
      <ion-item lines="none" class="ion-no-margin ion-no-padding">
        <ion-icon name="log-out-outline" 
              slot="end" 
              (click)="logoff()"
              *ngIf="usuarioLogado"  ></ion-icon>
      </ion-item>
    


    </ion-buttons>
    

    

  </ion-toolbar>

</ion-header>



